import { useEffect } from "react";
import { Link } from "react-router-dom";
import us_pc from "../../assets/images/us_pc.webp";
import us_mo from "../../assets/images/us_mo.webp";
import ar_white from "../../assets/images/ar_white.svg";
import home_white from "../../assets/images/home_white.svg";
import Contact from "../Contact/Contact";

export default function AppTermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -120;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="w-full bg-[#FAFCFE]">
      {/* Banner */}
      <div className="w-full">
        {/* Mobile Banner */}
        <div className="block md:hidden lg:hidden w-full relative h-[12rem] mt-16">
          <img src={us_mo} alt="" className="w-full h-[12rem] object-cover" />
          <div className="w-full absolute top-0 h-[12rem] bg-blue-sky-gradient6">
            <div className="absolute bottom-[20%] left-0 right-0 px-4 flex flex-col gap-2 items-center justify-center">
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img src={home_white} alt="Trang chủ" />
                </Link>
                <img src={ar_white} alt="" />
                <p className="text-[1rem] font-normal text-white">Điều khoản tải app</p>
              </div>
              <p className="text-[1.5rem] font-semibold text-white text-center">
                Điều khoản tải app
              </p>
            </div>
          </div>
        </div>

        {/* Desktop Banner */}
        <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
          <img src={us_pc} alt="" className="w-full h-[20rem] object-cover" />
          <div className="w-full absolute top-0 h-[20rem] bg-blue-sky-gradient6">
            <div className="absolute bottom-[35%] left-0 right-0 flex flex-col gap-2 items-center justify-center">
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img src={home_white} alt="Trang chủ" />
                </Link>
                <img src={ar_white} alt="" />
                <p className="text-[1rem] font-normal text-white">Điều khoản tải app</p>
              </div>
              <p className="text-[2.25rem] font-semibold text-white">
                Điều khoản tải app
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="container mx-auto px-4 py-8 lg:py-14 max-w-4xl">
        {/* Navigation Switcher / Breadcrumbs to other legal docs */}
        <div className="mb-8 flex flex-wrap items-center justify-between gap-3 p-3 bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="text-sm text-gray-500 font-medium">
            Tài liệu pháp lý & chính sách:
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to="/chinh-sach-bao-mat"
              className="px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:text-[#1375B7] hover:bg-sky-50 transition-colors"
            >
              Chính sách bảo mật
            </Link>
            <Link
              to="/dieu-khoan-su-dung"
              className="px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:text-[#1375B7] hover:bg-sky-50 transition-colors"
            >
              Điều khoản sử dụng
            </Link>
            <span className="px-3 py-1.5 rounded-lg text-sm font-medium bg-[#1375B7] text-white">
              Điều khoản tải app
            </span>
          </div>
        </div>

        {/* Header Document Overview Box */}
        <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-sky-100 mb-8">
          <div className="inline-block px-3 py-1 bg-sky-100 text-[#1375B7] text-xs font-semibold rounded-full uppercase tracking-wider mb-3">
            Bản đưa lên App
          </div>
          <h1 className="text-2xl lg:text-3xl font-bold text-[#1375B7] mb-4 leading-tight">
            Bản đưa lên App — Điều khoản và Chính sách dữ liệu tài khoản App
          </h1>
          <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-4 bg-gray-50 p-3.5 rounded-xl border border-gray-200">
            <span>
              Phiên bản văn bản: <strong className="text-gray-900">1.0</strong>
            </span>
            <span className="hidden sm:inline text-gray-300">·</span>
            <span>Soạn ngày 7/10/2026</span>
            <span className="hidden sm:inline text-gray-300">·</span>
            <span>
              Dán vào bước cuối của màn Đăng ký tài khoản trên App PH-HS và App Giáo viên / App Nhân viên.
            </span>
          </div>
          <div className="p-3.5 bg-amber-50 border-l-4 border-amber-400 rounded-r-xl text-amber-800 text-sm">
            <span className="font-semibold">Lưu ý biên tập:</span> Những chỗ trong dấu <code className="bg-amber-100 px-1.5 py-0.5 rounded text-amber-900 font-mono text-xs">&lt; &gt;</code> điền khi phát hành. Ngoài ra không sửa chữ.
          </div>
        </div>

        {/* Quick jump menu */}
        <div className="sticky top-20 z-20 mb-8 bg-white/95 backdrop-blur-md p-2.5 rounded-xl shadow-sm border border-gray-200 flex flex-wrap gap-2">
          <button
            onClick={() => scrollToSection("van-ban-1")}
            className="px-3.5 py-1.5 text-xs sm:text-sm font-medium rounded-lg bg-sky-50 text-[#1375B7] hover:bg-[#1375B7] hover:text-white transition-colors"
          >
            1. Điều khoản sử dụng tài khoản
          </button>
          <button
            onClick={() => scrollToSection("van-ban-2")}
            className="px-3.5 py-1.5 text-xs sm:text-sm font-medium rounded-lg bg-sky-50 text-[#1375B7] hover:bg-[#1375B7] hover:text-white transition-colors"
          >
            2. Chính sách dữ liệu cá nhân
          </button>
          <button
            onClick={() => scrollToSection("chu-tren-man-hinh")}
            className="px-3.5 py-1.5 text-xs sm:text-sm font-medium rounded-lg bg-sky-50 text-[#1375B7] hover:bg-[#1375B7] hover:text-white transition-colors"
          >
            3. Chữ trên màn hình
          </button>
        </div>

        {/* ===================== VĂN BẢN 1 ===================== */}
        <article id="van-ban-1" className="bg-white rounded-2xl p-6 lg:p-10 shadow-sm border border-gray-100 mb-10">
          <div className="border-b border-gray-100 pb-6 mb-8">
            <span className="text-xs font-bold tracking-widest text-sky-600 uppercase bg-sky-50 px-3 py-1 rounded-md">
              VĂN BẢN 1
            </span>
            <h2 className="text-2xl lg:text-3xl font-bold text-[#1375B7] mt-3 uppercase tracking-tight">
              ĐIỀU KHOẢN SỬ DỤNG TÀI KHOẢN APP
            </h2>
            <p className="text-sm text-gray-500 mt-2 font-medium">
              Phiên bản 1.0 — có hiệu lực từ <span className="font-mono text-[#1375B7] bg-sky-50 px-1.5 py-0.5 rounded">&lt;ngày phát hành&gt;</span>
            </p>

            <div className="mt-4 p-4 bg-sky-50/60 rounded-xl border border-sky-100 text-sm text-[#333] space-y-1">
              <p>
                <strong>Bên cung cấp:</strong> <span className="font-mono text-[#1375B7]">&lt;TÊN CÔNG TY&gt;</span>
              </p>
              <p>
                <strong>Địa chỉ:</strong> <span className="font-mono text-[#1375B7]">&lt;địa chỉ&gt;</span>
              </p>
              <p>
                <strong>Email:</strong> <span className="font-mono text-[#1375B7]">&lt;email hỗ trợ&gt;</span> · <strong>Điện thoại:</strong> <span className="font-mono text-[#1375B7]">&lt;số tổng đài&gt;</span>
              </p>
            </div>
          </div>

          <div className="space-y-8 text-[#333]">
            {/* 1 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">1. Tài khoản này là gì</h3>
              <p className="leading-7">
                Tài khoản App do chúng tôi cấp để bạn đăng nhập vào ứng dụng. Tài khoản chứng minh bạn đang giữ số điện thoại đã đăng ký, và chỉ chứng minh điều đó.
              </p>
              <p className="leading-7">
                Tài khoản này tự nó không mở được dữ liệu của trường nào. Bạn chỉ xem được dữ liệu của một trường sau khi chính nhà trường đó cho phép, theo cách nói ở Điều 6.
              </p>
            </section>

            {/* 2 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">2. Hai loại tài khoản</h3>
              <p className="leading-7">
                Ứng dụng dành cho phụ huynh và ứng dụng dành cho cán bộ, giáo viên, nhân viên dùng hai loại tài khoản riêng. Một số điện thoại có thể có tối đa một tài khoản mỗi loại. Hai loại hoạt động độc lập: tài khoản loại này bị khóa không ảnh hưởng tới tài khoản loại kia.
              </p>
            </section>

            {/* 3 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">3. Số điện thoại là tên đăng nhập và không đổi được</h3>
              <p className="leading-7">
                Số điện thoại là định danh của tài khoản. Chúng tôi không có chức năng đổi số điện thoại của một tài khoản.
              </p>
              <p className="leading-7">
                Nếu bạn đổi số, bạn cần đăng ký một tài khoản mới bằng số mới, rồi đề nghị nhà trường cấp lại liên kết cho tài khoản mới. Chúng tôi làm như vậy để nhà trường luôn biết số điện thoại nào đang xem dữ liệu của học sinh nào.
              </p>
            </section>

            {/* 4 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">4. Chúng tôi lưu những gì về bạn</h3>
              <p className="leading-7">
                Chỉ họ tên, số điện thoại, ảnh đại diện và email — trong đó ảnh và email là tùy chọn, bạn có thể không cung cấp.
              </p>
              <p className="leading-7">
                Chúng tôi không hỏi và không lưu số giấy tờ tùy thân, ngày sinh hay địa chỉ của bạn.
              </p>
              <p className="leading-7">
                Chi tiết về mục đích, thời hạn lưu và quyền của bạn nằm ở Chính sách dữ liệu cá nhân — văn bản bạn đồng ý cùng lúc với điều khoản này.
              </p>
            </section>

            {/* 5 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">5. Chúng tôi không lưu dữ liệu học tập và hồ sơ của bạn ở trường</h3>
              <p className="leading-7">
                Hồ sơ học sinh, điểm, chuyên cần, học bạ, hồ sơ nhân sự và mọi dữ liệu nghiệp vụ khác nằm trên máy chủ của nhà trường. Ứng dụng đọc trực tiếp từ nhà trường mỗi lần bạn mở; chúng tôi không giữ bản sao.
              </p>
              <p className="leading-7">
                Riêng chức năng Nhắn tin là ngoại lệ: nội dung tin nhắn, ảnh và tệp đính kèm do chúng tôi lưu. Việc đó có một văn bản riêng — Điều khoản Nhắn tin — mà bạn sẽ được hỏi đồng ý trước khi gửi tin nhắn đầu tiên. Không đồng ý văn bản đó thì bạn vẫn dùng bình thường mọi chức năng khác.
              </p>
            </section>

            {/* 6 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">6. Ai quyết định bạn xem được những gì</h3>
              <p className="leading-7">
                Nhà trường quyết định, không phải chúng tôi.
              </p>
              <p className="leading-7">
                Nếu bạn là phụ huynh: mỗi người con chỉ vào danh sách theo dõi của bạn khi bạn dùng một mã liên kết do nhà trường cấp — đường liên kết, mã QR hoặc mã ngắn. Ở bước xác nhận, ứng dụng cho bạn xem trước họ tên con, lớp và tên trường, và nói rõ rằng số điện thoại cùng họ tên tài khoản của bạn sẽ được gửi tới nhà trường. Việc gửi đó chỉ xảy ra khi bạn bấm Xác nhận.
              </p>
              <p className="leading-7">
                Nếu bạn là cán bộ, giáo viên, nhân viên: bạn phải tự đăng nhập trang quản trị của nhà trường và bấm Đồng ý để liên kết tài khoản App với hồ sơ của mình. Không ai đồng ý thay bạn được.
              </p>
            </section>

            {/* 7 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">7. Mật khẩu, mã OTP và mở nhanh</h3>
              <p className="leading-7">
                Mật khẩu do bạn đặt trên máy của bạn. Chúng tôi không bao giờ gửi mật khẩu cho bạn qua tin nhắn.
              </p>
              <p className="leading-7">
                Mã OTP sáu số được dùng ở hai lúc: khi đăng ký và khi bạn quên mật khẩu. Mã dùng một lần và có thời hạn.
              </p>
              <p className="leading-7">
                Bạn có thể bật mở nhanh bằng vân tay hoặc mã PIN. Chức năng này mặc định tắt, và nó chỉ mở khóa ứng dụng trên chiếc máy đó, không thay cho mật khẩu.
              </p>
              <p className="leading-7">
                Hãy giữ mật khẩu và mã OTP cho riêng mình. Mọi việc làm từ tài khoản của bạn được xem là do bạn thực hiện, trừ khi bạn đã báo cho chúng tôi rằng tài khoản bị chiếm dụng.
              </p>
            </section>

            {/* 8 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">8. Mỗi lúc một điện thoại</h3>
              <p className="leading-7">
                Một tài khoản chỉ dùng được trên một điện thoại tại một thời điểm. Khi bạn đăng nhập trên máy mới, ứng dụng báo trước trên chính máy mới rằng máy đang dùng sẽ bị đăng xuất, và chỉ tiếp tục khi bạn đồng ý.
              </p>
              <p className="leading-7">
                Đổi máy không cần xin lại mã liên kết. Các liên kết đi theo tài khoản của bạn.
              </p>
            </section>

            {/* 9 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">9. Nhà trường có thể khóa hoặc ngừng một liên kết</h3>
              <p className="leading-7">
                Nhà trường có thể tạm khóa hoặc ngừng hẳn một liên kết của bạn với một học sinh. Khi đó bạn không xem được dữ liệu của em đó nữa, nhưng tài khoản App của bạn vẫn còn và các liên kết khác không bị ảnh hưởng.
              </p>
              <p className="leading-7">
                Quyết định này thuộc nhà trường. Chúng tôi không biết lý do và không thay đổi được. Nếu bạn không đồng ý, xin liên hệ văn phòng nhà trường.
              </p>
            </section>

            {/* 10 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">10. Bạn liên hệ ai</h3>
              <p className="leading-7">
                Liên hệ chúng tôi về: đăng ký, mã OTP, mật khẩu, tài khoản bị khóa, xóa tài khoản, lỗi ứng dụng.
              </p>
              <p className="leading-7">
                Liên hệ nhà trường về: mã liên kết, thêm hoặc bớt con, hồ sơ học sinh, điểm, học phí, và mọi nội dung nghiệp vụ khác.
              </p>
            </section>

            {/* 11 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">11. Bạn có thể xóa tài khoản bất cứ lúc nào</h3>
              <p className="leading-7">
                Trong mục Tài khoản. Để tránh xóa do nhầm, chúng tôi hỏi mã OTP gửi về số của bạn và yêu cầu bạn gõ lại số điện thoại.
              </p>
              <p className="leading-7">Xin đọc trước ba hệ quả:</p>
              <ul className="list-disc pl-6 space-y-2 leading-7 text-gray-700">
                <li>Mọi liên kết của bạn ở mọi trường sẽ dừng; các con rời khỏi danh sách theo dõi.</li>
                <li>Dữ liệu của con bạn ở trường không bị xóa. Dữ liệu đó thuộc nhà trường quản lý, không thuộc tài khoản này.</li>
                <li>Muốn dùng lại, bạn phải đăng ký tài khoản mới và xin nhà trường cấp mã liên kết mới.</li>
              </ul>
            </section>

            {/* 12 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">12. Những việc bạn không được làm</h3>
              <p className="leading-7">
                Dùng tài khoản của người khác. Cung cấp thông tin không đúng khi đăng ký. Tìm cách xem dữ liệu không thuộc về mình. Can thiệp vào hoạt động của ứng dụng hoặc của hệ thống nhà trường.
              </p>
              <p className="leading-7">
                Nếu bạn làm những việc trên, chúng tôi có thể khóa tài khoản App theo điều khoản này. Việc khóa tài khoản App không phải là một hình thức kỷ luật của nhà trường, và cũng không thay thế cho việc nhà trường xử lý theo quy định của nhà trường.
              </p>
            </section>

            {/* 13 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">13. Dịch vụ có lúc tạm dừng</h3>
              <p className="leading-7">
                Chúng tôi bảo trì định kỳ và thông báo trước khi có thể. Khi máy chủ của nhà trường không kết nối được, ứng dụng nói rõ điều đó thay vì hiển thị dữ liệu cũ như dữ liệu mới.
              </p>
            </section>

            {/* 14 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">14. Điều khoản này có phiên bản</h3>
              <p className="leading-7">
                Khi chúng tôi thay đổi dữ liệu thu thập, nơi lưu dữ liệu, những ai nhận dữ liệu, hoặc quyền và nghĩa vụ của bạn, chúng tôi phát hành phiên bản mới và hỏi bạn đồng ý lại.
              </p>
              <p className="leading-7">
                Trong lúc bạn chưa đồng ý phiên bản mới, bạn vẫn xem được dữ liệu của con mình và vẫn nhận được thông báo của nhà trường. Những việc tạm dừng là: thêm con, sửa thông tin tài khoản, gửi tin nhắn và đăng ký dịch vụ.
              </p>
              <p className="leading-7">
                Bạn luôn xem được phiên bản đang áp dụng, phiên bản bạn đã đồng ý và thời điểm đồng ý trong mục Tài khoản.
              </p>
            </section>

            {/* 15 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">15. Liên hệ và khiếu nại</h3>
              <p className="leading-7">
                Email <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;email hỗ trợ&gt;</span> · Điện thoại <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;số tổng đài&gt;</span> · Địa chỉ <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;địa chỉ&gt;</span>.
              </p>
              <p className="leading-7">
                Chúng tôi trả lời khiếu nại trong 15 ngày làm việc kể từ ngày nhận được.
              </p>
              <p className="leading-7">
                Điều khoản này được điều chỉnh theo pháp luật Việt Nam. Hai bên ưu tiên thương lượng; không thương lượng được thì giải quyết tại tòa án có thẩm quyền theo pháp luật Việt Nam.
              </p>
            </section>
          </div>
        </article>

        {/* ===================== VĂN BẢN 2 ===================== */}
        <article id="van-ban-2" className="bg-white rounded-2xl p-6 lg:p-10 shadow-sm border border-gray-100 mb-10">
          <div className="border-b border-gray-100 pb-6 mb-8">
            <span className="text-xs font-bold tracking-widest text-sky-600 uppercase bg-sky-50 px-3 py-1 rounded-md">
              VĂN BẢN 2
            </span>
            <h2 className="text-2xl lg:text-3xl font-bold text-[#1375B7] mt-3 uppercase tracking-tight">
              CHÍNH SÁCH DỮ LIỆU CÁ NHÂN — TÀI KHOẢN APP
            </h2>
            <p className="text-sm text-gray-500 mt-2 font-medium">
              Phiên bản 1.0 — có hiệu lực từ <span className="font-mono text-[#1375B7] bg-sky-50 px-1.5 py-0.5 rounded">&lt;ngày phát hành&gt;</span>
            </p>

            <div className="mt-4 p-4 bg-sky-50/60 rounded-xl border border-sky-100 text-sm text-[#333] space-y-1">
              <p>
                <strong>Bên kiểm soát dữ liệu của tài khoản App:</strong> <span className="font-mono text-[#1375B7]">&lt;TÊN CÔNG TY&gt;</span>
              </p>
              <p>
                <strong>Đầu mối phụ trách bảo vệ dữ liệu cá nhân:</strong> <span className="font-mono text-[#1375B7]">&lt;email&gt;</span> · <span className="font-mono text-[#1375B7]">&lt;số điện thoại&gt;</span>
              </p>
            </div>
          </div>

          <div className="space-y-8 text-[#333]">
            {/* 1 */}
            <section className="space-y-3">
              <h3 className="text-lg font-bold text-[#1375B7]">1. Chúng tôi thu thập gì và để làm gì</h3>
              <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-xs">
                <table className="w-full text-left text-sm border-collapse">
                  <thead>
                    <tr className="bg-sky-50 text-[#1375B7] border-b border-gray-200 font-semibold">
                      <th className="py-3 px-4 w-1/4">Thông tin</th>
                      <th className="py-3 px-4 w-1/2">Để làm gì</th>
                      <th className="py-3 px-4 w-1/4">Lưu đến khi nào</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 leading-relaxed text-gray-700">
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Số điện thoại (bắt buộc)</td>
                      <td className="py-3 px-4">Tên đăng nhập; gửi mã OTP</td>
                      <td className="py-3 px-4">Hết thời gian bạn còn tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Họ tên (bắt buộc)</td>
                      <td className="py-3 px-4">Hiển thị trong ứng dụng; gửi tới nhà trường khi bạn xác nhận liên kết</td>
                      <td className="py-3 px-4">Hết thời gian bạn còn tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Mật khẩu (bắt buộc)</td>
                      <td className="py-3 px-4">Đăng nhập. Chúng tôi lưu ở dạng đã mã hóa một chiều, không đọc lại được</td>
                      <td className="py-3 px-4">Hết thời gian bạn còn tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Ảnh đại diện (tùy chọn)</td>
                      <td className="py-3 px-4">Hiển thị trong ứng dụng</td>
                      <td className="py-3 px-4">Đến khi bạn xóa ảnh hoặc xóa tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Email (tùy chọn)</td>
                      <td className="py-3 px-4">Liên hệ hỗ trợ</td>
                      <td className="py-3 px-4">Đến khi bạn xóa email hoặc xóa tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Danh sách mã trường bạn đã liên kết, kèm ngày</td>
                      <td className="py-3 px-4">Để ứng dụng biết gọi về máy chủ trường nào; để chúng tôi báo đúng các trường khi bạn xóa tài khoản</td>
                      <td className="py-3 px-4">Đến khi liên kết cuối cùng ở trường đó kết thúc</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Nhật ký đăng nhập và thiết bị đang dùng</td>
                      <td className="py-3 px-4">Bảo mật: chặn đăng nhập lạ, thực hiện quy tắc mỗi lúc một điện thoại</td>
                      <td className="py-3 px-4">12 tháng</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Phiên bản điều khoản bạn đã đồng ý, kèm thời điểm</td>
                      <td className="py-3 px-4">Chứng minh bạn đã được hỏi và đã đồng ý</td>
                      <td className="py-3 px-4">Hết thời gian bạn còn tài khoản</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* 2 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">2. Chúng tôi không thu thập</h3>
              <p className="leading-7">
                Số giấy tờ tùy thân; ngày sinh; địa chỉ; nghề nghiệp; quan hệ của bạn với học sinh.
              </p>
              <p className="leading-7">
                Và chúng tôi không lưu những thông tin sau, dù ứng dụng có hiển thị chúng cho bạn: họ tên và lớp của con bạn; hồ sơ, điểm, chuyên cần, học bạ của học sinh; hồ sơ nhân sự và chức danh của bạn ở trường; mã liên kết nhà trường cấp; ghi chú của nhà trường về học sinh.
              </p>
              <p className="leading-7">
                Những thông tin đó nằm trên máy chủ nhà trường và đi trực tiếp tới máy của bạn.
              </p>
            </section>

            {/* 3 */}
            <section className="space-y-3">
              <h3 className="text-lg font-bold text-[#1375B7]">3. Những ai nhận dữ liệu của bạn</h3>
              <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-xs">
                <table className="w-full text-left text-sm border-collapse">
                  <thead>
                    <tr className="bg-sky-50 text-[#1375B7] border-b border-gray-200 font-semibold">
                      <th className="py-3 px-4 w-1/4">Nhận</th>
                      <th className="py-3 px-4 w-1/2">Nhận gì</th>
                      <th className="py-3 px-4 w-1/4">Khi nào</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 leading-relaxed text-gray-700">
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Nhà trường bạn liên kết</td>
                      <td className="py-3 px-4">Họ tên và số điện thoại của tài khoản, không gì khác</td>
                      <td className="py-3 px-4">Chỉ khi bạn bấm Xác nhận ở màn thêm con, hoặc bấm Đồng ý trên trang quản trị của trường</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900 font-mono text-[#1375B7]">&lt;tên đơn vị gửi tin nhắn&gt;</td>
                      <td className="py-3 px-4">Số điện thoại và nội dung mã OTP</td>
                      <td className="py-3 px-4">Mỗi lần bạn yêu cầu mã</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900 font-mono text-[#1375B7]">&lt;tên đơn vị cung cấp hạ tầng máy chủ&gt;</td>
                      <td className="py-3 px-4">Lưu trữ dữ liệu ở trạng thái mã hóa</td>
                      <td className="py-3 px-4">Liên tục, theo hợp đồng</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Cơ quan nhà nước có thẩm quyền</td>
                      <td className="py-3 px-4">Theo đúng phạm vi được yêu cầu</td>
                      <td className="py-3 px-4">Khi có yêu cầu hợp pháp bằng văn bản</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="leading-7 font-medium text-[#1375B7]">
                Chúng tôi không bán, không trao đổi, không dùng dữ liệu của bạn cho quảng cáo.
              </p>
            </section>

            {/* 4 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">4. Dữ liệu được lưu ở đâu</h3>
              <p className="leading-7">
                Trên máy chủ đặt tại Việt Nam.
              </p>
            </section>

            {/* 5 */}
            <section className="space-y-3">
              <h3 className="text-lg font-bold text-[#1375B7]">5. Quyền của bạn và chỗ thực hiện</h3>
              <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-xs">
                <table className="w-full text-left text-sm border-collapse">
                  <thead>
                    <tr className="bg-sky-50 text-[#1375B7] border-b border-gray-200 font-semibold">
                      <th className="py-3 px-4 w-1/3">Bạn muốn</th>
                      <th className="py-3 px-4 w-2/3">Làm ở đâu</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 leading-relaxed text-gray-700">
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Xem lại dữ liệu chúng tôi giữ về bạn</td>
                      <td className="py-3 px-4">Mục Tài khoản — toàn bộ nằm ở đó</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Sửa họ tên, ảnh, email</td>
                      <td className="py-3 px-4">Mục Tài khoản</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Rút ảnh hoặc email đã cung cấp</td>
                      <td className="py-3 px-4">Mục Tài khoản — xóa ô đó</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Đổi số điện thoại</td>
                      <td className="py-3 px-4">Không có chức năng này. Số điện thoại là tên đăng nhập. Bạn đăng ký tài khoản mới bằng số mới, rồi xin nhà trường cấp mã liên kết mới</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Xóa toàn bộ tài khoản</td>
                      <td className="py-3 px-4">Mục Tài khoản — xác nhận bằng mã OTP và gõ lại số điện thoại</td>
                    </tr>
                    <tr className="hover:bg-gray-50/70">
                      <td className="py-3 px-4 font-medium text-gray-900">Khiếu nại về cách chúng tôi xử lý dữ liệu</td>
                      <td className="py-3 px-4">
                        <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;email&gt;</span> hoặc <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;số điện thoại&gt;</span> — chúng tôi trả lời trong 15 ngày làm việc
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* 6 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">6. Dữ liệu của trẻ em</h3>
              <p className="leading-7">
                Tài khoản App không chứa dữ liệu của học sinh. Hồ sơ, điểm và kết quả học tập của con bạn do nhà trường quản lý. Nhà trường là bên chịu trách nhiệm về dữ liệu đó và có văn bản riêng gửi tới phụ huynh.
              </p>
              <p className="leading-7">
                Ngoại lệ duy nhất là chức năng Nhắn tin: nội dung tin nhắn do chúng tôi lưu và có thể chứa thông tin về học sinh. Việc đó được nói riêng trong Điều khoản Nhắn tin, kèm thời hạn lưu cụ thể, và bạn đồng ý riêng trước khi gửi tin nhắn đầu tiên.
              </p>
            </section>

            {/* 7 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">7. Khi bạn xóa tài khoản</h3>
              <p className="leading-7">
                Chúng tôi xóa họ tên, ảnh, email, mật khẩu và danh sách mã trường trong 30 ngày. Chúng tôi thông báo cho từng trường bạn đã liên kết để nhà trường dừng các liên kết đó.
              </p>
              <p className="leading-7">
                Nhật ký bảo mật được giữ thêm 12 tháng rồi xóa.
              </p>
              <p className="leading-7">
                Dữ liệu của con bạn ở trường không bị xóa cùng. Việc đó bạn đề nghị với nhà trường.
              </p>
            </section>

            {/* 8 */}
            <section className="space-y-2.5">
              <h3 className="text-lg font-bold text-[#1375B7]">8. Khi chính sách này thay đổi</h3>
              <p className="leading-7">
                Chúng tôi phát hành phiên bản mới và hỏi bạn đồng ý lại. Bạn xem được phiên bản đang áp dụng và phiên bản bạn đã đồng ý trong mục Tài khoản.
              </p>
            </section>
          </div>
        </article>

        {/* ===================== CHỮ TRÊN MÀN HÌNH ===================== */}
        <article id="chu-tren-man-hinh" className="bg-white rounded-2xl p-6 lg:p-10 shadow-sm border border-gray-100 mb-10">
          <div className="border-b border-gray-100 pb-6 mb-8">
            <span className="text-xs font-bold tracking-widest text-sky-600 uppercase bg-sky-50 px-3 py-1 rounded-md">
              HƯỚNG DẪN GIAO DIỆN
            </span>
            <h2 className="text-2xl lg:text-3xl font-bold text-[#1375B7] mt-3 uppercase tracking-tight">
              CHỮ TRÊN MÀN HÌNH
            </h2>
            <div className="mt-3 p-3.5 bg-sky-50 border-l-4 border-[#1375B7] rounded-r-xl text-sm text-[#1375B7] font-medium">
              Dán đúng từng chữ. Nút Tạo tài khoản để mờ cho đến khi ô được tích; ô không tích sẵn.
            </div>
          </div>

          <div className="space-y-6 text-[#333]">
            {/* Mục 1 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Câu dẫn đầu màn
              </h4>
              <p className="text-base text-gray-900 font-medium">
                Trước khi tạo tài khoản, xin đọc hai văn bản sau:
              </p>
            </div>

            {/* Mục 2 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Hai dòng mở văn bản
              </h4>
              <div className="space-y-1.5 font-medium text-gray-900">
                <p className="text-[#1375B7] underline underline-offset-2">
                  Điều khoản sử dụng tài khoản — phiên bản 1.0
                </p>
                <p className="text-[#1375B7] underline underline-offset-2">
                  Chính sách dữ liệu cá nhân — phiên bản 1.0
                </p>
              </div>
            </div>

            {/* Mục 3 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Câu bên ô tích
              </h4>
              <p className="text-base text-gray-900 leading-relaxed">
                Tôi đã đọc và đồng ý Điều khoản sử dụng tài khoản và Chính sách dữ liệu cá nhân của <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;TÊN CÔNG TY&gt;</span>.
              </p>
            </div>

            {/* Mục 4 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Nút
              </h4>
              <div className="inline-block px-5 py-2.5 rounded-lg bg-gray-300 text-gray-600 font-semibold text-sm cursor-not-allowed">
                Tạo tài khoản
              </div>
            </div>

            {/* Mục 5 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Khi bấm nút mà chưa tích
              </h4>
              <p className="text-base text-gray-900">
                Nút không bật. Không hiện thông báo lỗi.
              </p>
            </div>

            {/* Mục 6 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Trong mục Tài khoản, sau khi đã đăng ký
              </h4>
              <div className="space-y-2 text-gray-900">
                <p>
                  Điều khoản sử dụng tài khoản — phiên bản 1.0 · Bạn đã đồng ý ngày <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;ngày&gt;</span>
                </p>
                <p>
                  Chính sách dữ liệu cá nhân — phiên bản 1.0 · Bạn đã đồng ý ngày <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;ngày&gt;</span>
                </p>
                <p className="text-[#1375B7] font-semibold underline underline-offset-2">
                  Đọc lại
                </p>
              </div>
            </div>

            {/* Mục 7 */}
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Dải nhắc khi có phiên bản mới
              </h4>
              <div className="space-y-3 text-gray-900 leading-relaxed">
                <p>
                  Chúng tôi đã cập nhật <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;tên văn bản&gt;</span> lên phiên bản <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;số&gt;</span>. Thay đổi lần này: <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;nói đúng thứ đã đổi, một câu&gt;</span>. Bạn đã đồng ý phiên bản <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;số cũ&gt;</span> ngày <span className="font-mono text-[#1375B7] bg-sky-50 px-1 rounded">&lt;ngày&gt;</span>.
                </p>
                <p>
                  Trong lúc bạn chưa đồng ý, bạn vẫn xem được dữ liệu của con và vẫn nhận thông báo của nhà trường. Tạm dừng: thêm con, sửa thông tin tài khoản, gửi tin nhắn, đăng ký dịch vụ.
                </p>
              </div>
            </div>
          </div>
        </article>
      </div>

      <Contact />
    </div>
  );
}
